import { render, staticRenderFns } from "./inventoryInformation.vue?vue&type=template&id=74da77d0&scoped=true&"
import script from "./inventoryInformation.vue?vue&type=script&lang=js&"
export * from "./inventoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./inventoryInformation.vue?vue&type=style&index=0&id=74da77d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da77d0",
  null
  
)

export default component.exports